// extracted by mini-css-extract-plugin
module.exports = {"Article":"Article_Article_Article__Hw7td","Title":"Article_Article_Title__l4Oj5","Story":"Article_Article_Story__XML7_","Related":"Article_Article_Related__aIAAd"};